'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var brand = require('../../types/brand.js');
require('../../types/cms/enums.js');

/**
 * Helper that processes a StyleAttribute with the valueType of 'font_variant_reference'.
 *
 * This type of style attribute represents data made up of either a font-weight
 * or font-style or both. The data model combines these data points as it best
 * reflects the UI where this style is created, however, on the consumer side
 * we need to split these into at most 2 style attributes. This will provide
 * the consumers a consistent and CSS like data structure.
 *
 * @param styleAttribute
 */
const transformFontVariantStyleAttribute = (styleAttribute) => {
    const { devices, transformedValue } = styleAttribute;
    const transformedStyleAttributes = [];
    if (typeof transformedValue === 'object' && transformedValue.fontStyle) {
        transformedStyleAttributes.push({
            devices,
            name: 'font-style',
            transformedValue: transformedValue.fontStyle,
            valueType: brand.BrandStyleAttributeValueType.Text
        });
    }
    if (typeof transformedValue === 'object' && transformedValue.fontWeight) {
        transformedStyleAttributes.push({
            devices,
            name: 'font-weight',
            transformedValue: transformedValue.fontWeight,
            valueType: brand.BrandStyleAttributeValueType.Number
        });
    }
    return transformedStyleAttributes;
};
const prepareBrandStylesForConsumer = (brandStyles) => {
    const processedBrandStyles = {
        base: brandStyles.base,
        styles: []
    };
    const styles = [];
    for (const [, brandStyle] of Object.entries(brandStyles.styles)) {
        const copiedBrandStyle = { ...brandStyle, attributes: [] };
        for (const [, attributeObjs] of Object.entries(brandStyle.attributes)) {
            const styleAttributes = Object.values(attributeObjs).reduce((styles, styleAttribute) => {
                if (styleAttribute.valueType ===
                    brand.BrandStyleAttributeValueType.FontVariantReference) {
                    styles.push(...transformFontVariantStyleAttribute(styleAttribute));
                }
                else {
                    styles.push(styleAttribute);
                }
                return styles;
            }, []);
            copiedBrandStyle.attributes = [
                ...copiedBrandStyle.attributes,
                ...styleAttributes
            ];
        }
        styles.push(copiedBrandStyle);
    }
    processedBrandStyles.styles = styles;
    return processedBrandStyles;
};

exports.prepareBrandStylesForConsumer = prepareBrandStylesForConsumer;
//# sourceMappingURL=prepareBrandStylesForConsumer.js.map
